import * as Yup from 'yup';
import { getRequiredText } from '../../../../../global/helpers/transformer';
import { LabelSettingProps } from '../../../../../global/models/epi-model';
import { CompensationProps } from '../../../models/arc-epi-props';

export interface ScheduledPaymentFormValues {
    effective_date: string;
    cash_salary: number | string;
    er_plan_contributions: number | string;
    housing_cash_allowance: number | string;
    housing_provided: string;
}

export const ScheduledPaymentValidationSchema = (compensationProps: CompensationProps, labelSettings: LabelSettingProps) => {
    return Yup.object().shape({
        effective_date: Yup.date().nullable().required(getRequiredText(labelSettings.requiredFormat, compensationProps.effectiveDateLabel)),
        cash_salary: Yup.number().round('floor').moreThan(-1, labelSettings.notNegative),
        er_plan_contributions: Yup.number().round('floor').moreThan(-1, labelSettings.notNegative),
        housing_cash_allowance: Yup.number().round('floor').moreThan(-1, labelSettings.notNegative),
    });
};